export const SERIES_LABEL: Record<string, string> = {
  X20: 'X20 System',
  X67: 'X67 System',
  X90: 'X90 System',
}

export const STOCK_STATUS_LABEL: Record<string, string> = {
  in_stock: 'Op voorraad',
  low_stock: 'Beperkt op voorraad',
  on_order: 'Op bestelling',
  unknown: 'Leverbaar',
  out_of_stock: 'Niet op voorraad',
}

// Five delivery windows (WEB-392, DEC-022). 'unknown' is excluded from the filter
// but kept here for completeness.
export const DELIVERY_SPEED_LABEL: Record<string, string> = {
  days_3: '< 3 dagen',
  week_1: '< 1 week',
  weeks_2_3: '2-3 weken',
  weeks_3_4: '3-4 weken',
  unknown: 'Onbekend',
}

export const LIFECYCLE_LABEL: Record<string, string> = {
  active: 'Actief',
  new: 'Nieuw',
  mature: 'Mature',
  phase_out: 'Uitfaseren',
  end_of_life: 'End-of-life',
  obsolete: 'Obsoleet',
}
